<template lang="pug">
.page-new
	//- .modal-header.justify-content-start.align-items-center.p-2.border-bottom-0.page-title(onclick='location.href='index-logged-in.html'')
	router-link.modal-header.justify-content-start.align-items-center.p-2.border-bottom-0.page-title(to="/")
		.arrow-left
			i.fas.fa-chevron-left
		.modal-title.text-capitalize.pl-3 {{$t('ui.home')}}
	.subtitle-wrap.d-block.d-lg-none
		.bg-subtitle
			.page-subtitle promotions
	.page-wrap02.page-promo
		.row.mx-0
			.col-md-6.px-0(v-for="(promo, index) in getPromoList")
				//- router-link(:to="{name: 'promo-details', params: {promo: '1'}}")
				a(href="javascript:void(0)" @click="triggerDeposit(promo.promotion_id)")
					.promo-item
						.promo-pic
							img.w-100.img-fluid(:src="'img/promo/promotion0'+ (index+1) + '.png'")
							.promo-title
								.title01 {{promo.promotion_name}}
							.promo-detail-wrapper
								.promo-detail-col
									.promo-info-title {{$t('ui.bonus')}}:
									.promo-info-amount {{promo.bonus_rate}}
								.promo-detail-col
									.promo-info-title Min Deposit:
									.promo-info-amount {{promo.min_deposit}}
								.promo-detail-col
									.promo-info-title Rollover:
									.promo-info-amount {{promo.rollover}}
								.promo-detail-col
									.promo-info-title Criteria:
									.promo-info-amount {{promo.criteria}}
			
</template>
<script>
import promoItem from '@/component/_promoItems.vue'
export default {
	components:{
		promoItem
	},
	data(){
		return{
			promoSelected: []
		}
	},
	// beforeRouteEnter(to, from, next){
	// 	var vm = this
	// 	if(vm.$store.state.user.account.system_type !== 'CASH'){
	// 		next(vm => {
	// 			vm.$router.replace({name: "home"})
	// 		})
	// 	}else{

	// 	}
    
  // },
	computed:{
		accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
		getPromoList(){
      return this.$store.getters.promoList.data.PROMOTION_LIST
    },
	},
	created(){
		if(this.$store.getters.isLoggedIn){
			if(this.getPromoList.length > 0){
				
			}else{
				this.$router.replace({ name: "home" });
			}
		}
	},
	
  mounted(){
		window.scroll(0, 0)
		this.getPromo()
  },
	methods:{
		triggerDeposit(id){
			this.promoSelected = []
			this.$store.dispatch("user/setPromoSelected", id)
			this.getPromoList.filter(x => x.promotion_id == id).forEach(y => {
        this.promoSelected.push(y)
      })
      this.$store.dispatch("user/setPromoDetail", this.promoSelected)
			this.$nextTick(() => $('#modal-deposit').modal('show'));
			
		},
		getPromo(){
      if (this.sessionToken) {
        let member_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getPromo", { member_id, auth_token })
          .then(response => {
            if (response.success == true) {
              this.$store
                .dispatch("user/sPromo", { data: response.data })
                .then(() => {
                  
                })
                .catch(err => console.log(err))
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {console.log(response)
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          });
      }
    },
	}
}
</script>
<style lang="scss" scoped>
.promo-detail-col{
	flex: 0 0 20% !important;
}
</style>